import { NumericBoolean, format } from '@bilibili-maoer/web-utils'

import { Typography, css, styled } from '@mui/material'
import { unescape } from 'lodash'

import { Announcement } from './types'

import { StyledTitleRouterLink } from '~/core/components/link'
import { notificationUnreadMark, textOverflow } from '~/core/styles'
import { rmHtml } from '~/core/utils/html'

const StyledItemContainer = styled('div')`
  color: #000;
  &:not(:nth-last-child(2)) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 30px;
  }
`

const StyledTitleWrapper = styled('div')`
  display: flex;
`

const StyledSpan = styled('span')`
  color: #bdbdbd; /** $grey-lighter */
`

const StyledContentSpan = styled('span')`
  ${textOverflow('75%')}
  display: inline-block;
  color: #757575; /** $grey-light */
  & > p {
    margin: 0;
    padding: 0;
  }
`

const StyledTypography = styled(Typography)`
  display: flex;
`

const StyledTitleRouterLinkMayUnread = styled(StyledTitleRouterLink)<{ notice: NumericBoolean }>(
  ({ notice }) => css`
    display: flex;
    ${!!notice && notificationUnreadMark({ top: '12px' })}
  `
)

export const AnnouncementItem = (props: { announcement: Announcement }) => {
  const intro = props.announcement.intro ? unescape(rmHtml(props.announcement.intro)) : ''
  return (
    <StyledItemContainer>
      <StyledTitleWrapper>
        <StyledTitleRouterLinkMayUnread
          notice={props.announcement.notice}
          to={props.announcement.to}
          sx={{ flex: '1' }}
        >
          <StyledTypography variant="h6" sx={{ fontWeight: '700', fontSize: '18px', marginBottom: '10px' }}>
            {props.announcement.title}
          </StyledTypography>
        </StyledTitleRouterLinkMayUnread>
        <StyledSpan>{format.formatUTCTimeBySeconds(props.announcement.ctime, 'YYYY-MM-DD HH:mm:ss')}</StyledSpan>
      </StyledTitleWrapper>
      <StyledContentSpan
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line @typescript-eslint/naming-convention -- 需要展示 HTML
          __html: intro,
        }}
      />
    </StyledItemContainer>
  )
}
